
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function About() {
  const clientReviews = [
    {
      name: "Arjun Reddy",
      position: "Managing Director",
      company: "Prestige Group",
      review: "Lavin Enterprises has been instrumental in our success across multiple residential projects. Their deep understanding of construction chemicals and commitment to quality has made them our preferred partner for over a decade.",
      rating: 5,
      project: "Premium Residential Towers",
      image: "Professional Indian managing director in corporate office setting, confident real estate executive in formal business attire, modern office background with architectural plans and building models"
    },
    {
      name: "Dr. Sunita Agarwal",
      position: "Technical Director",
      company: "Engineers India Limited",
      review: "The technical expertise and innovative solutions provided by Lavin Enterprises have consistently exceeded our expectations. Their team's knowledge and support have been invaluable to our infrastructure projects.",
      rating: 5,
      project: "Industrial Infrastructure",
      image: "Professional Indian female technical director in engineering office, experienced technical professional with engineering drawings, modern technical facility background with industrial equipment"
    },
    {
      name: "Ravi Krishnan",
      position: "Project Manager",
      company: "NBCC India",
      review: "Working with Lavin Enterprises for government projects has been exceptional. Their reliability, quality standards, and timely delivery have made them our trusted partner for critical infrastructure development.",
      rating: 5,
      project: "Government Housing Project",
      image: "Professional Indian project manager at government construction site, experienced public sector professional with safety helmet, government building construction background with official signage"
    },
    {
      name: "Meera Jain",
      position: "Quality Head",
      company: "Sobha Limited",
      review: "The consistency in quality and technical support from Lavin Enterprises has been remarkable. Their products have helped us maintain the highest standards across all our luxury developments.",
      rating: 5,
      project: "Luxury Villa Development",
      image: "Professional Indian quality head at luxury construction site, confident quality control professional with inspection equipment, premium residential development background with elegant architecture"
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-20 min-h-[80vh] flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20with%20glass%20architecture%20and%20steel%20structures%2C%20professional%20business%20environment%20with%20clean%20geometric%20design%2C%20contemporary%20commercial%20building%20exterior%20with%20blue%20sky%20background%2C%20architectural%20excellence%20showcasing%20innovation%20and%20growth%2C%20bright%20natural%20lighting%20with%20urban%20skyline&width=1920&height=800&seq=about-hero-corporate&orientation=landscape"
            alt="Advanced Chemical Solutions"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
          <div className="absolute inset-0" style={{ backgroundColor: 'rgba(69, 82, 74, 0.3)' }}></div>
        </div>

        {/* Content */}
        <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              
              {/* Left Content */}
              <div className="text-white">
                {/* Company Badge */}
                <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
                  <i className="ri-award-line text-emerald-300 mr-2"></i>
                  <span className="text-sm font-medium text-emerald-100">Established Industry Leader</span>
                </div>

                {/* Main Heading */}
                <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                  <span className="block text-white drop-shadow-lg">About</span>
                  <span className="block bg-gradient-to-r from-emerald-300 to-cyan-300 bg-clip-text text-transparent drop-shadow-lg">
                    Lavin Enterprises
                  </span>
                  <span className="block text-3xl lg:text-4xl font-semibold mt-2" style={{ color: '#45524A' }}>
                    &amp; Co.
                  </span>
                </h1>

                {/* Description */}
                <p className="text-xl text-emerald-50 leading-relaxed mb-8 max-w-lg">
                  Your trusted nationwide partner delivering advanced construction chemical solutions with 
                  <span className="font-semibold text-white"> technical excellence</span> and 
                  <span className="font-semibold text-white"> unmatched reliability</span>.
                </p>

                {/* Key Stats */}
                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="text-center p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                    <div className="text-3xl font-bold text-emerald-300 mb-1">15+</div>
                    <div className="text-sm text-emerald-100">States Covered</div>
                  </div>
                  <div className="text-center p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                    <div className="text-3xl font-bold text-cyan-300 mb-1">50+</div>
                    <div className="text-sm text-cyan-100">Distribution Centers</div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4">
                  <button className="px-8 py-4 rounded-lg font-semibold text-white transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap" 
                          style={{ backgroundColor: '#45524A' }}>
                    <i className="ri-building-line mr-2"></i>
                    Our Journey
                  </button>
                  <button className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/30 rounded-lg font-semibold text-white hover:bg-white/20 transition-all duration-300 whitespace-nowrap">
                    <i className="ri-team-line mr-2"></i>
                    Meet Our Team
                  </button>
                </div>
              </div>

              {/* Right Content - Feature Cards */}
              <div className="space-y-6">
                <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(69, 82, 74, 0.8)' }}>
                      <i className="ri-flask-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">Advanced R&amp;D</h3>
                      <p className="text-emerald-100 text-sm leading-relaxed">
                        Cutting-edge research and development in construction chemical solutions with international quality standards.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-emerald-600/80 rounded-lg flex items-center justify-center">
                      <i className="ri-shield-check-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">Quality Assurance</h3>
                      <p className="text-emerald-100 text-sm leading-relaxed">
                        ISO certified processes ensuring every product meets the highest performance and safety standards.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-cyan-600/80 rounded-lg flex items-center justify-center">
                      <i className="ri-customer-service-2-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">Expert Support</h3>
                      <p className="text-emerald-100 text-sm leading-relaxed">
                        Dedicated technical support team providing on-ground assistance and applicator training nationwide.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-1/4 right-10 w-2 h-2 bg-emerald-300 rounded-full opacity-60 animate-pulse"></div>
        <div className="absolute top-1/2 right-1/4 w-1 h-1 bg-cyan-300 rounded-full opacity-40 animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/3 right-20 w-3 h-3 bg-white/30 rounded-full opacity-50 animate-pulse" style={{ animationDelay: '2s' }}></div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            
            {/* Company Overview */}
            <div className="mb-16">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-3xl font-bold mb-6" style={{ color: '#45524A' }}>Who We Are</h2>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    Lavin Enterprises &amp; Co. is a leading Pan-India distributor of high-performance construction chemicals. With deep sector expertise and a strong supply network across states, we bridge the gap between premium global brands and real-world on-site needs.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Whether it's strengthening concrete, ensuring waterproofing, offering durable flooring solutions, or sealing structural joints — we deliver <strong>technical excellence and service you can trust.</strong>
                  </p>
                </div>
                <div className="relative">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Modern%20construction%20site%20with%20advanced%20chemical%20solutions%20being%20applied%2C%20professional%20workers%20in%20safety%20gear%20applying%20construction%20chemicals%20to%20concrete%20structures%2C%20industrial%20setting%20with%20quality%20control%20equipment%2C%20bright%20lighting%20showcasing%20technical%20excellence%20and%20precision%20work&width=600&height=400&seq=about-company&orientation=landscape"
                    alt="Construction Chemical Solutions"
                    className="rounded-lg shadow-lg object-cover w-full h-80"
                  />
                </div>
              </div>
            </div>

            {/* Company History & Milestones */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>Our Journey &amp; Milestones</h2>
              <div className="bg-white p-8 rounded-lg shadow-md">
                <div className="space-y-8">
                  <div className="flex items-start space-x-6">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(69, 82, 74, 0.1)' }}>
                      <i className="ri-building-line text-2xl" style={{ color: '#45524A' }}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Foundation &amp; Early Years</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Established with a vision to revolutionize the construction chemical industry in India. Started as a regional distributor with a focus on quality and customer service, quickly gaining recognition for our technical expertise and reliable supply chain.
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-6">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(69, 82, 74, 0.1)' }}>
                      <i className="ri-global-line text-2xl" style={{ color: '#45524A' }}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">National Expansion</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Expanded operations across multiple states, establishing strategic partnerships with leading international brands. Built a robust distribution network covering major metros and tier-2/3 cities, ensuring nationwide reach and local understanding.
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-6">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(69, 82, 74, 0.1)' }}>
                      <i className="ri-award-line text-2xl" style={{ color: '#45524A' }}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Industry Recognition</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Achieved multiple industry certifications and awards for excellence in distribution and customer service. Recognized as a preferred partner by major construction companies and government projects across India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Our Promise */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>Our Promise</h2>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderColor: '#45524A' }}>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(69, 82, 74, 0.1)' }}>
                      <i className="ri-award-line text-2xl" style={{ color: '#45524A' }}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Quality Across Brands</h3>
                      <p className="text-gray-600">We are brand-agnostic but partner with the most reliable names in the industry. Every product we distribute is tested against international quality, performance, and safety standards.</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-green-600">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                      <i className="ri-tools-line text-2xl text-green-600"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Technical Support</h3>
                      <p className="text-gray-600">Distribution is only the beginning. We provide on-ground support, design inputs, and applicator training to ensure long-term durability.</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-purple-600">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                      <i className="ri-global-line text-2xl text-purple-600"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Pan-India Reach</h3>
                      <p className="text-gray-600">From metros to tier-2/3 cities, we understand regional challenges (climate, substrates, logistics) and customize solutions accordingly.</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-orange-600">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                      <i className="ri-truck-line text-2xl text-orange-600"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Timely Delivery</h3>
                      <p className="text-gray-600">With efficient inventory management and logistics, we ensure your projects never face downtime due to lack of material.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Leadership Team */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>Leadership Team</h2>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20Indian%20business%20executive%20in%20formal%20attire%2C%20confident%20leadership%20portrait%2C%20modern%20office%20background%2C%20experienced%20construction%20industry%20professional%2C%20clean%20corporate%20headshot%20with%20professional%20lighting&width=200&height=200&seq=ceo-portrait&orientation=squarish"
                      alt="CEO Portrait"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Rajesh Lavin</h3>
                  <p className="text-gray-600 mb-3">Chief Executive Officer</p>
                  <p className="text-sm text-gray-500">
                    With over 20 years in the construction chemical industry, Rajesh leads our strategic vision and expansion across India.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20Indian%20female%20business%20executive%20in%20formal%20attire%2C%20confident%20technical%20director%20portrait%2C%20modern%20office%20background%2C%20experienced%20chemical%20engineering%20professional%2C%20clean%20corporate%20headshot%20with%20professional%20lighting&width=200&height=200&seq=cto-portrait&orientation=squarish"
                      alt="CTO Portrait"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Dr. Priya Sharma</h3>
                  <p className="text-gray-600 mb-3">Chief Technical Officer</p>
                  <p className="text-sm text-gray-500">
                    Chemical Engineering PhD with expertise in construction materials, leading our technical innovation and quality assurance.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20Indian%20business%20executive%20in%20formal%20attire%2C%20confident%20operations%20director%20portrait%2C%20modern%20office%20background%2C%20experienced%20supply%20chain%20professional%2C%20clean%20corporate%20headshot%20with%20professional%20lighting&width=200&height=200&seq=coo-portrait&orientation=squarish"
                      alt="COO Portrait"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Amit Kumar</h3>
                  <p className="text-gray-600 mb-3">Chief Operations Officer</p>
                  <p className="text-sm text-gray-500">
                    Operations specialist managing our nationwide distribution network and ensuring seamless supply chain efficiency.
                  </p>
                </div>
              </div>
            </div>

            {/* Client Reviews Section */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>Client Testimonials</h2>
              <div className="grid md:grid-cols-2 gap-8">
                {clientReviews.map((review, index) => (
                  <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                    <div className="flex items-center mb-6">
                      <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                        <img 
                          src={`https://readdy.ai/api/search-image?query=$%7Breview.image%7D&width=150&height=150&seq=about-client-${index}&orientation=squarish`}
                          alt={review.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-gray-800">{review.name}</h3>
                        <p className="text-sm text-gray-600">{review.position}</p>
                        <p className="text-sm font-medium" style={{ color: '#45524A' }}>{review.company}</p>
                      </div>
                    </div>

                    <div className="flex mb-4">
                      {[...Array(review.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                      ))}
                    </div>

                    <p className="text-gray-700 leading-relaxed mb-4 italic">
                      "{review.review}"
                    </p>

                    <div className="border-t pt-4">
                      <div className="flex items-center text-sm text-gray-500">
                        <i className="ri-building-line mr-2"></i>
                        <span>{review.project}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Our Reach */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>Our Reach &amp; Footprint</h2>
              <div className="p-8 rounded-lg" style={{ background: 'linear-gradient(to right, rgba(69, 82, 74, 0.1), rgba(69, 82, 74, 0.05))' }}>
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      With operations across India, we maintain warehouses and distribution hubs in key regions to ensure <strong>consistent and timely supply.</strong>
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      Our presence spans Delhi NCR, Uttar Pradesh, Rajasthan, Gujarat, Maharashtra, and beyond — backed by long-standing partnerships with regional applicators, RMC plants, and government project authorities.
                    </p>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                        <div className="text-2xl font-bold" style={{ color: '#45524A' }}>15+</div>
                        <div className="text-sm text-gray-600">States Covered</div>
                      </div>
                      <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                        <div className="text-2xl font-bold" style={{ color: '#45524A' }}>50+</div>
                        <div className="text-sm text-gray-600">Distribution Centers</div>
                      </div>
                    </div>
                  </div>
                  <div className="relative">
                    <img 
                      src="https://readdy.ai/api/search-image?query=India%20map%20showing%20distribution%20network%20with%20warehouse%20locations%20marked%2C%20logistics%20trucks%20and%20supply%20chain%20visualization%2C%20professional%20business%20map%20with%20regional%20coverage%20indicators%2C%20modern%20distribution%20centers%20across%20different%20states&width=500&height=350&seq=india-reach&orientation=landscape"
                      alt="Pan-India Distribution Network"
                      className="rounded-lg shadow-md object-cover w-full h-64"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Certifications & Partnerships */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>Certifications &amp; Partnerships</h2>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Quality Certifications</h3>
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <i className="ri-medal-line text-green-500 text-xl mr-3"></i>
                      <span className="text-gray-700">ISO 9001:2015 Quality Management</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-medal-line text-green-500 text-xl mr-3"></i>
                      <span className="text-gray-700">ISO 14001:2015 Environmental Management</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-medal-line text-green-500 text-xl mr-3"></i>
                      <span className="text-gray-700">OHSAS 18001 Safety Management</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-medal-line text-green-500 text-xl mr-3"></i>
                      <span className="text-gray-700">BIS Certification for Construction Chemicals</span>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Strategic Partnerships</h3>
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <i className="ri-handshake-line text-blue-500 text-xl mr-3"></i>
                      <span className="text-gray-700">Global Chemical Manufacturers</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-handshake-line text-blue-500 text-xl mr-3"></i>
                      <span className="text-gray-700">Leading Construction Companies</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-handshake-line text-blue-500 text-xl mr-3"></i>
                      <span className="text-gray-700">Government Infrastructure Projects</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-handshake-line text-blue-500 text-xl mr-3"></i>
                      <span className="text-gray-700">Technical Research Institutes</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sustainability Commitment */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>Sustainability Commitment</h2>
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-8 rounded-lg">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">Environmental Responsibility</h3>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      We are committed to promoting sustainable construction practices through eco-friendly chemical solutions and responsible business operations.
                    </p>
                    <div className="space-y-3">
                      <div className="flex items-center">
                        <i className="ri-leaf-line text-green-600 text-xl mr-3"></i>
                        <span className="text-gray-700">Green building material solutions</span>
                      </div>
                      <div className="flex items-center">
                        <i className="ri-recycle-line text-green-600 text-xl mr-3"></i>
                        <span className="text-gray-700">Waste reduction initiatives</span>
                      </div>
                      <div className="flex items-center">
                        <i className="ri-water-percent-line text-green-600 text-xl mr-3"></i>
                        <span className="text-gray-700">Water conservation technologies</span>
                      </div>
                    </div>
                  </div>
                  <div className="relative">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Sustainable%20construction%20site%20with%20eco-friendly%20building%20materials%2C%20green%20construction%20practices%2C%20solar%20panels%20and%20environmental%20protection%20equipment%2C%20workers%20using%20sustainable%20chemical%20solutions%2C%20clean%20energy%20and%20environmental%20responsibility&width=500&height=300&seq=sustainability&orientation=landscape"
                      alt="Sustainable Construction Practices"
                      className="rounded-lg shadow-md object-cover w-full h-64"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Vision */}
            <div className="text-center text-white p-12 rounded-lg" style={{ backgroundColor: '#45524A' }}>
              <h2 className="text-3xl font-bold mb-6">Our Vision</h2>
              <p className="text-xl leading-relaxed mb-4">
                To be India&apos;s <strong>most trusted and technically empowered</strong> construction chemical distributor.
              </p>
              <p className="text-lg opacity-90">
                We aim to set new benchmarks in service, reliability, and technical excellence — so that every structure built with our support stands strong, sustainable, and future-ready.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
